import { HttpInstance } from "lib/HttpLib";

// [GET] 회원 위치 통계 가져오기
export const getMemberLocationStats = (queryData) => {
  const { branch_info, created_at_from, created_at_to, reg_type, mbshp_option, page_number } =
    queryData;

  return HttpInstance.get(process.env.REACT_APP_BRANCH_SERVER + "/statistics/location", {
    params: {
      branch_id: branch_info.branch_id,
      created_at_from: created_at_from,
      created_at_to: created_at_to,
      reg_type: reg_type,
      mbshp_option: mbshp_option,
      page_size: 15,
      page_number: page_number,
    },
  });
};
